import { format } from "date-fns"
import { Calendar as CalendarIcon } from "lucide-react"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"

export const DatePicker = ({ date,
  setDate,
  isDisabled = false,
  className,
  calendarMaxDate,
  calendarMinDate,
}: {
  date: Date | undefined,
  setDate: React.Dispatch<React.SetStateAction<Date | undefined>>
  isDisabled?: boolean,
  className?: string,
  calendarMaxDate?: Date,
  calendarMinDate?: Date
}) => {

  const getMaximumCalendarDate = () => {
    const currentDate = new Date()
    const oneYearAfter = new Date(currentDate)
    oneYearAfter.setFullYear(currentDate.getFullYear() + 2)
    return oneYearAfter
  }

  return (
    <Popover>
      {!isDisabled ? (
        <PopoverTrigger asChild>
          <Button
            className={
              cn(`relative justify-between text-left font-normal 
                bg-foreground text-primary border border-input`, className)}
          >
            {date ? format(date, "PPP") : ''}
            <CalendarIcon className="mr-2 h-4 w-4 absolute right-2 top-3" />
          </Button>
        </PopoverTrigger>
      ) : (
        <div className={cn(`h-10 relative flex flex-row items-center pl-3 text-left text-sm 
            font-normal bg-muted-foreground text-secondary border border-input`, className)}>
          {date ? format(date, "PPP") : ''}
          <CalendarIcon className="mr-2 h-4 w-4 absolute right-2 top-3" />
        </div>
      )}
      <PopoverContent className="w-auto p-0">
        <Calendar
          disabled={(date) =>
            date > (calendarMaxDate ?? getMaximumCalendarDate()) || date < (calendarMinDate ?? new Date())
          }
          mode="single"
          selected={date}
          onSelect={setDate}
          initialFocus
        />
      </PopoverContent>
    </Popover >
  )
}
